import { Injectable } from '@angular/core';
import { MotorVehicleVersionLicensePlate } from '@app/core/interfaces/motor-vehicle';
import { RequestService } from '@app/core/request/request.service';
import { ApiProductIdEnum } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const RESOURCES = {
    LICENSE_PLATE: 'motorvoertuig-algemeen/opvragen/uitvoering-motorvoertuigen-kenteken',
};

@Injectable({
    providedIn: 'root',
})
export class InsuranceIMICService {
    constructor(private request: RequestService) {}

    public downloadFile(filePath: string, fileName: string): void {
        const link = document.createElement('a');
        link.href = filePath;
        link.download = fileName;
        link.click();
    }

    public getCaravanLicencePlate$(licenceplate: string): Observable<MotorVehicleVersionLicensePlate> {
        const payload = {
            data: {
                kenteken: this.formatLicencePlate(licenceplate),
                // WINS-7636 change to PolicyProductIdEnum when mapper is available
                product_id: ApiProductIdEnum.Caravan,
            },
        };

        return this.request.post(RESOURCES.LICENSE_PLATE, payload).pipe(map((resultaat) => resultaat.data));
    }

    public formatLicencePlate(value: string): string {
        return value.replace(/[-\s]/g, '').toUpperCase();
    }
}
